import React from "react";
import { Button } from "@amzn/awsui-components-console";
import {
  FixedFeeConfig,
  SimplifiedFixedFeeConfig,
} from "@amzn/fuse-accounting-central-datastore-client";

interface ValidateActionProps {
  fixedFeeConfig?: FixedFeeConfig | SimplifiedFixedFeeConfig;
  ldap: string;
  onValidate?: () => void;
}

/**
 * Renders the "Validate" button.
 *
 * - Only visible to users in the "bart-admin" LDAP group.
 * - Disabled when there is no selected fixedFeeConfig.
 * - Invokes onValidate when clicked.
 */
export const ValidateAction: React.FC<ValidateActionProps> = ({
  fixedFeeConfig,
  ldap,
  onValidate,
}) => {
  if (!ldap.includes("bart-admin")) return null;

  return (
    <Button
      variant="normal"
      iconName="search"
      disabled={!fixedFeeConfig}
      onClick={onValidate}
    >
      Validate
    </Button>
  );
};
